import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { AuthenticationService, UserService } from 'app/services';
import { CrmMenuService } from 'app/services/crm-menu.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { OrderWidgetsComponent } from './order-widgets/order-widgets.component';
import { WgInternalPoliciesComponent } from './widget/wg-internal-policies/wg-internal-policies.component';
import { WgProceduresComponent } from './widget/wg-procedures/wg-procedures.component';
import { WgEmployeesBgChecksComponent } from './widget/wg-employe-bg-checks/wg-employees-bg-checks.component';
import { WgLearningResourcesComponent } from './widget/wg-learning-resources/wg-learning-resources.component';
import { WgIndividualEmployeesStatusComponent } from './widget/wg-individual-employe-status/wg-individual-employees-status.component';
import { WgAmlOfficerComponent } from './widget/wg-aml-officer/wg-aml-officer.component';
import { WgActiveDossiersComponent } from './widget/wg-active-dossiers/wg-active-dossiers.component';
import { WgReportingComponent } from './widget/wg-reporting/wg-reporting.component';
import { WgWhistleblowerComponent } from './widget/wg-whistleblower/wg-whistleblower.component';
import { WgStatisticsComponent } from './widget/wg-statistics/wg-statistics.component';
import { WgCreditsComponent } from './widget/wg-credits/wg-credits.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class HomeComponent implements OnInit {
   
    widgetsList: any[]  = [
        {
            widget : WgInternalPoliciesComponent,
            id : 'app-wg-internal-policies',
            title:"Internal policies",
            order: 0,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
            
        },
        {
            widget : WgProceduresComponent,
            id : 'app-wg-procedures',
            title:"Procedures",
            order : 1,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,

        },
        {
            widget: WgEmployeesBgChecksComponent,
            id: 'app-wg-employees-bg-checks',
            title:"Employees background checks",
            order: 2,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
        },
        {
            widget : WgLearningResourcesComponent,
            id : 'app-wg-learning-resources',
            title:"E-learning resources & links",
            order: 3,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
        },
        {
            widget: WgIndividualEmployeesStatusComponent,
            id: 'app-wg-individual-employees-status',
            title:"E-learning status individual employees",
            order: 4,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
        },
        {
            widget: WgAmlOfficerComponent,
            id: 'app-wg-aml-officer',
            title:"Anti-Money Laundry Officer",
            order: 5,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
        },
        {
            widget: WgActiveDossiersComponent,  
            id: 'app-wg-active-dossiers',
            title: "Active Dossiers",
            order: 6,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
        },
        {
            widget: WgReportingComponent,
            id: 'app-wg-reporting',
            title:"Reporting STR / SAR",
            order: 7,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
        },
        {
            widget: WgWhistleblowerComponent,
            id: 'app-wg-whistleblower',
            title:"Whistleblower area ceplac F19",
            order: 8,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true,
        },
        {
            widget: WgStatisticsComponent,
            id: 'app-wg-statistics',
            title:"Statistics",
            order: 9,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true
        },
        {
            widget: WgCreditsComponent,
            id: 'app-wg-credits',
            title:"Credits",
            order: 11,
            fxFlex:"100",
            fxFlexGtSm:"50",
            visible:true
        }
    ];
    user: any;
    isCommercialModule: any;
    isResidentialModule: any;
    isInvoiceModule: any;
    rpaId: any;
    currentAgency: any;
    private _unsubscribeAll: Subject<any>;
    currentLang: string;
    modelWidgets = [] as any;
    loadingResults = false as boolean;
    constructor(
        private _authenticationService: AuthenticationService,
        private _crmMenuService: CrmMenuService,
        private _fuseSidebarService: FuseSidebarService,
        private _router: Router,
        private _matDialog: MatDialog,
        private _translateService: TranslateService,
        private _userService: UserService,
    ) {
        this.user = this._authenticationService.currentUserValue;
        this.isCommercialModule = this._crmMenuService.isCommercialModule;
        this.isResidentialModule = this._crmMenuService.isPropertyModule;
        this.isInvoiceModule = this._crmMenuService.isInvoiceModule;
        this.currentAgency = this._authenticationService.currentAgencyValue;
        this._unsubscribeAll = new Subject();
        this.currentLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
    }
    ngOnInit(): void {
        if (this.user.user_role === 'agent_portal') {
            this._router.navigate(['/dashboard/home-cb']);
        }
        this.getWidgetsOrder();
        
    }
    
    openProperties(event: any): void {
        window.scrollTo(0, 0);
        this.rpaId = event;
        this._fuseSidebarService.getSidebar('rpa').toggleOpen();
    }

    onOpenedChanged(event: any): void {
        if (!event) {
            delete this.rpaId;
        }
    }
    
    reOrder(): void {
        const matDialog = this._matDialog.open(OrderWidgetsComponent, {
            panelClass: 'order-widgets',
            data: this.widgetsList,
        });
        matDialog.afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: any) => {
                if (response) {
                    this._userService.updateDashboardWidgetsOrder(response)
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe(() => {
                            this.getWidgetsOrder();
                        });
                }
            });
    }
    
    getWidgetsOrder(): any {
        this.loadingResults = true;
        this._userService.getDashboardWidgetsOrder()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((data: any[]) => {
                if(data && data?.length > 0){
                    let frontendWidgets = [];
                    data.map((dbwidget) => {
                        const match = this.widgetsList.find(widget => widget.id === dbwidget.id);  
                        if(match){
                            match.order = dbwidget.order;
                            match.visible = dbwidget.visible;
                            frontendWidgets.push(match);
                        }
                    })
                    this.widgetsList = frontendWidgets;
                }
                this.widgetsList.forEach(widget => {
                    widget.isActive = true; 
                });
                this.loadingResults = false;
            });
    }
}
